/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useState, useEffect, BaseSyntheticEvent} from 'react'
import {PageTitle} from '../../../../../_metronic/layout/core'
import {Datatable} from '../../../../components/Datatable/Datatable'
import type {MetaType} from '../../../../components/Datatable/Datatable'
import {Button} from '../../../../components/Button/Button'
import {useNavigate} from 'react-router-dom'
import {GET, PUT, POST, DELETE} from '../../../../services/api'
import {Loading} from '../../../../components/Loading/Loading'
import Swal from 'sweetalert2'
import {BreadCrumbs} from '../../../../components/BreadCrumbs/breadCrumbrs'
import {useSwitchStatus} from '../../../../components/Datatable/SwitchStatus'
import {ModalDelete} from '../../../../components/Modals/General/ModalDelete/ModalDelete'
import useModals from '../../../../hooks/useModals'
import {i18n} from '../../../../translate/i18n'

type CategoryType = {
  id: number
  parent: string
  code: string
  name: string
  shortname: string
  order: number
  img: string
  status: true
  subitems: CategoryType[]
}

const Content: FC = () => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const {showDeleteModal} = useModals()
  const [categories, setCategories] = useState<any[]>([])
  const [id, setId] = useState<number | null>(null)
  const [meta, setMeta] = useState<MetaType | undefined>(undefined)
  const [qtdCategorias, setqtdCategorias] = useState(0)
  const {switchStatus} = useSwitchStatus()

  const getCategories = async () => {
    try {
      setLoading(true)

      /* const res = await POST(`/classification/filter`, {
        plugintypeId: 10,
        deleted: 'not show',
      }) */
      const res = await POST(`/session-hotel-classification/filter`, {
        deleted: 'not show',
      })
      const newCategories = res.data.map((row: CategoryType) => {
        return {
          id: row.id,
          name: `${row.name}`,
          status: row.status,
          order: row.order,
        }
      })

      setCategories(newCategories)
      setqtdCategorias(res.meta.itemCount)
      setMeta(res.meta)
      setLoading(false)
    } catch (e) {
      setLoading(false)
      console.log(e)
    }
  }

  const canDelete = async () => {
    try {
      setLoading(true)
      const res = await DELETE(`/session-hotel-classification/${id}`)
      if (res.success === true) {
        Swal.fire({
          icon: 'success',
          title: String(i18n.t('hospitality_content.category.swal.deleted_title')),
          text: String(i18n.t('hospitality_content.category.swal.deleted_text')),
        }).then(async () => await getCategories())
      } else {
        console.log(res)
        Swal.fire({
          icon: 'error',
          title: String(i18n.t('hospitality_content.messages.filter_error_title')),
          text: String(i18n.t('hospitality_content.category.swal.delete_error')),
        }).then(async () => await getCategories())
      }
      setLoading(false)
    } catch (e) {
      setLoading(false)
      Swal.fire({
        icon: 'error',
        title: String(i18n.t('hospitality_content.messages.filter_error_title')),
        text: String(i18n.t('hospitality_content.category.swal.delete_error')),
      }).then(async () => await getCategories())
      console.log(e)
    }
  }

  function init() {
    getCategories()
  }

  useEffect(() => {
    init()
  }, [])

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className='row g-5 gx-xxl-12'>
          <div className='card card-xxl-stretch mb-5 mb-xl-12'>
            <div className='card-header py-5'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-3 mb-1'>
                  {i18n.t('hospitality_content.category.page_title')}
                </span>
                <BreadCrumbs />
                <span className='text-muted mt-1 fw-bold fs-7'>
                  {i18n.t('hospitality_content.category.page_subtitle')}
                </span>
              </h3>
              <div className='card-toolbar'>
                <Button
                  text={String(i18n.t('hospitality_content.category.add_button'))}
                  color='primary'
                  iconColor='#FFF'
                  icon='fas fa-plus'
                  size='small'
                  horizontalPadding={6}
                  btnAttr={{
                    type: 'button',
                  }}
                  click={() => navigate('/hospitality/content/category/criar')}
                  btnClass='mb-5 fw-bolder'
                />
              </div>
            </div>
            <div className='card-body'>
              <Datatable
                data={categories}
                headers={[
                  {
                    key: String(i18n.t('hospitality_content.category.table.headers.section')),
                    value: 'name',
                    type: 'default',
                  },
                  {
                    key: String(i18n.t('hospitality_content.category.table.headers.order')),
                    value: 'order',
                    type: 'default',
                  },
                  {
                    key: String(i18n.t('hospitality_content.category.table.headers.status')),
                    value: 'status',
                    type: 'check',
                    action: (item) =>
                      switchStatus({
                        endpoint: 'session-hotel-classification',
                        Id: item.id,
                        status: item.status,
                      }),
                  },
                  {
                    key: String(i18n.t('hospitality_content.category.table.headers.actions')),
                    value: 'acoes',
                    type: '',
                  },
                ]}
                options={[
                  {
                    icon: 'fas fa-pen',
                    title: String(i18n.t('hospitality_content.category.options.edit_category')),
                    action: (item) => {
                      navigate(`/hospitality/content/category/editar/${item.id}`)
                    },
                  },
                  {
                    icon: 'fas fa-trash',
                    action: (item) => {
                      showDeleteModal(
                        String(i18n.t('hospitality_content.category.options.delete_confirm'))
                      )
                      setId(item.id)
                    },
                    title: String(i18n.t('hospitality_content.category.options.delete_section')),
                  },
                ]}
                color='primary'
              />
            </div>
          </div>
          <ModalDelete confirmAction={() => canDelete()} />
        </div>
      )}
    </>
  )
}

const FeedCategorias: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            title: String(i18n.t('hospitality_content.category.breadcrumbs.dashboard')),
            path: 'dashboard',
            isActive: true,
          },
        ]}
      >
        {i18n.t('hospitality_content.category.page_title')}
      </PageTitle>
      <Content />
    </>
  )
}

export {FeedCategorias}
